// third-party
import { configureStore } from '@reduxjs/toolkit'
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from 'react-redux'

import { persistStore, persistReducer } from 'redux-persist'

// project imports
import rootReducer from './reducer'
import storage from 'redux-persist/lib/storage'

// ==============================|| REDUX - MAIN STORE ||============================== //
const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
})

const persister = persistStore(store)

const { dispatch } = store

const useDispatch = () => useAppDispatch()
const useSelector = useAppSelector

export { store, persister, dispatch, useSelector, useDispatch }
